var map = {
	"./forestDetailBio.svg": "1962",
	"./forestDetailCo2.svg": "84ac",
	"./forestDetailSpecies.svg": "f0cf",
	"./forestDetailSurvival.svg": "4e77",
	"./forestDetailTree.svg": "accb",
	"./forestDetailWildlife.svg": "0da1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4013";